import type { TipoAvaliacao } from '../../api/hooks/useAvaliacoes';
import { BIMESTRES, TIPO_LABELS } from './avaliacoes-professor-shared';
import type { AvaliacoesProfessorPageContext } from './useAvaliacoesProfessorPage';

type Props = Pick<
  AvaliacoesProfessorPageContext,
  'formData' | 'setFormData' | 'minhasTurmas' | 'minhasMaterias' | 'handleCriar' | 'criar' | 'setShowForm'
> & {
  /** Desktop: acoes no footer do Modal */
  hideActions?: boolean;
};

export function AvaliacoesFormBlock({
  formData,
  setFormData,
  minhasTurmas,
  minhasMaterias,
  handleCriar,
  criar,
  setShowForm,
  hideActions = false,
}: Props) {
  return (
    <>
      <div className="aval-form-grid">
        <div className="full">
          <label className="aval-form-label">Título *</label>
          <input
            type="text"
            className="aval-form-input"
            value={formData.titulo}
            onChange={(e) => setFormData({ ...formData, titulo: e.target.value })}
            placeholder="Ex: Prova 1 - História"
          />
        </div>
        <div>
          <label className="aval-form-label">Tipo</label>
          <select
            className="aval-form-select"
            value={formData.tipo}
            onChange={(e) => setFormData({ ...formData, tipo: e.target.value as TipoAvaliacao })}
          >
            {Object.entries(TIPO_LABELS).map(([k, v]) => (
              <option key={k} value={k}>
                {v.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="aval-form-label">Bimestre</label>
          <select
            className="aval-form-select"
            value={formData.bimestre}
            onChange={(e) => setFormData({ ...formData, bimestre: Number(e.target.value) })}
          >
            {BIMESTRES.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="aval-form-label">Turma *</label>
          <select
            className="aval-form-select"
            value={formData.turmaId}
            onChange={(e) => setFormData({ ...formData, turmaId: e.target.value })}
          >
            <option value="">Selecione</option>
            {minhasTurmas.map((t) => (
              <option key={t.id} value={t.id}>
                {t.nome}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="aval-form-label">Matéria *</label>
          <select
            className="aval-form-select"
            value={formData.materiaId}
            onChange={(e) => setFormData({ ...formData, materiaId: e.target.value })}
          >
            <option value="">Selecione</option>
            {minhasMaterias.map((m) => (
              <option key={m.id} value={m.id}>
                {m.nome}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="aval-form-label">Data de aplicação</label>
          <input
            type="date"
            className="aval-form-input"
            value={formData.dataAplicacao}
            onChange={(e) => setFormData({ ...formData, dataAplicacao: e.target.value })}
          />
        </div>
        <div>
          <label className="aval-form-label">Peso</label>
          <input
            type="number"
            step={0.1}
            min={0}
            className="aval-form-input"
            value={formData.peso}
            onChange={(e) => setFormData({ ...formData, peso: parseFloat(e.target.value) || 0 })}
          />
        </div>
        <div>
          <label className="aval-form-label">Nota máxima</label>
          <input
            type="number"
            step={0.5}
            min={0}
            className="aval-form-input"
            value={formData.valorMaximo}
            onChange={(e) =>
              setFormData({ ...formData, valorMaximo: parseFloat(e.target.value) || 0 })
            }
          />
        </div>
        <div className="full">
          <label className="aval-form-label">Descrição</label>
          <textarea
            className="aval-form-input"
            rows={2}
            value={formData.descricao}
            onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
            placeholder="Instruções opcionais"
          />
        </div>
      </div>
      {!hideActions && (
        <div className="aval-form-actions">
          <button type="button" className="aval-form-btn-secondary" onClick={() => setShowForm(false)}>
            Cancelar
          </button>
          <button
            type="button"
            className="aval-form-btn-primary"
            onClick={handleCriar}
            disabled={!formData.titulo || !formData.turmaId || !formData.materiaId || criar.isPending}
          >
            {criar.isPending ? 'Salvando...' : 'Criar'}
          </button>
        </div>
      )}
    </>
  );
}
